import styled from '@emotion/styled';
import React from 'react';

import { hexToRgba } from 'src/shared/helpers/hexToRgba';
import { color, font } from 'src/shared/styles/variables';

const TopicsWrapper = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
});

interface TopicProps {
    selected?: boolean;
    disabled?: boolean;
    capitalize?: boolean;
    displayOnly?: boolean;
}

const Topic = styled('div')<TopicProps>(
    ({ capitalize, displayOnly }) => ({
        padding: '0.66rem 1.09rem 0.53rem',
        margin: '0.70rem 0.70rem 0rem 0rem',
        borderRadius: 20.5,
        color: displayOnly ? color.white : color.scooter,
        backgroundColor: displayOnly ? color.scooter : hexToRgba(color.scooter, 0.2),
        cursor: displayOnly ? 'default' : 'pointer',
        textTransform: capitalize ? 'capitalize' : 'none',
        transition: 'all 0.2s',
        pointerEvents: displayOnly ? 'none' : 'auto',
        '&:hover': {
            backgroundColor: color.easternBlue,
            color: color.white,
        },
    }),
    ({ selected }) =>
        selected && {
            backgroundColor: color.scooter,
            color: color.white,
        },
    ({ disabled }) =>
        disabled && {
            backgroundColor: color.athensGray,
            color: color.dustyGray,
            pointerEvents: 'none',
        },

    font.roman(font.size.medium),
);

interface Props {
    topics: string[];
    selectedTopics?: string[];
    disabledTopics?: string[];
    capitalize?: boolean;
    displayOnly?: boolean;
    onTopicChange?: (topic: string) => void;
}

export const Topics: React.SFC<Props> = ({
    topics,
    selectedTopics = [],
    disabledTopics = [],
    onTopicChange,
    capitalize,
    displayOnly,
}) => (
    <TopicsWrapper>
        {topics.map(topic => (
            <Topic
                capitalize={capitalize}
                displayOnly={displayOnly}
                selected={selectedTopics.includes(topic)}
                disabled={disabledTopics.includes(topic) && !selectedTopics.includes(topic)}
                onClick={() => onTopicChange && onTopicChange(topic)}
                key={topic}
            >
                {topic}
            </Topic>
        ))}
    </TopicsWrapper>
);
